<tp-system-banner></tp-system-banner>
<router-outlet></router-outlet>
<tp-walkthrough-spotlight></tp-walkthrough-spotlight>
<tp-agent-chat-sheet></tp-agent-chat-sheet>
<tp-global-alert></tp-global-alert>
